export enum AtomDateTypeEnum {
  CALENDAR = "calendar",
  CUSTOM = "custom",
  FROM_NOW = "fromNow",
}
